module.exports = __webpack_public_path__ + "img/icon_host_empty_blue.0ad10d51.svg";